export type AwardRow = Record<string, unknown>
export function normalizeGallery(response: unknown): AwardRow[] {
  if (!response || typeof response !== 'object' || !Array.isArray((response as { data?: unknown }).data)) throw new TypeError('Invalid achievement response')
  return (response as { data: unknown[] }).data.map(row => row && typeof row === 'object' && !Array.isArray(row) ? row as AwardRow : {})
}
export function metric(value: unknown): number | null {
  if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return null
  const number = Number(value)
  return Number.isFinite(number) && number >= 0 ? number : null
}
export function displayText(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.trim() ? value : fallback
}
export function imageUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null
  try { const url = new URL(value); return ['http:', 'https:'].includes(url.protocol) ? url.href : null } catch { return null }
}
